import { render, staticRenderFns } from "./SendRecieveBuy.vue?vue&type=template&id=a83bcc5c&scoped=true&"
import script from "./SendRecieveBuy.vue?vue&type=script&lang=js&"
export * from "./SendRecieveBuy.vue?vue&type=script&lang=js&"
import style0 from "./SendRecieveBuy.vue?vue&type=style&index=0&id=a83bcc5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83bcc5c",
  null
  
)

export default component.exports